import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import Select, { AsyncSelect } from '@atlaskit/select';
import { getDropDownMenuPosition } from '../common/commonDropDownMenuProps';
import { SelectErrorContainer } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
import { messages } from './messages';
export const EditDropdown = ({
  id,
  options,
  value,
  loading,
  loadOptions,
  onChange,
  hasOtherOption,
  otherOptionSelected,
  otherOptionText,
  onOtherOptionTextChange,
  isInvalid,
  isRequired,
  customComponents
}) => {
  const [hasBeenFocused, setHasBeenFocused] = useState(false);
  if (loadOptions === undefined) {
    return /*#__PURE__*/React.createElement(SelectErrorContainer, {
      isInvalid: isInvalid
    }, /*#__PURE__*/React.createElement(Select, _extends({
      id: id,
      options: options,
      value: value !== null && value !== void 0 ? value : null,
      isLoading: loading,
      onChange: onChange,
      isSearchable: true,
      noOptionsMessage: () => /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions),
      placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
      isRequired: fg('proforma_a11y_mandatory_fields') ? isRequired : undefined
    }, getDropDownMenuPosition(), {
      labelId: fg('proforma_a11y_group_controls_for_screen_reader') ? id : undefined
    })), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
      dropdown: true,
      value: otherOptionText,
      isDisabled: !otherOptionSelected,
      onChange: onOtherOptionTextChange,
      id: id
    }));
  }
  return /*#__PURE__*/React.createElement(SelectErrorContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(AsyncSelect, _extends({
    autoFocus: hasBeenFocused,
    defaultMenuIsOpen: hasBeenFocused,
    defaultOptions: hasBeenFocused,
    id: id,
    isSearchable: true,
    key: id + hasBeenFocused,
    isLoading: loading,
    noOptionsMessage: () => /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions),
    loadOptions: loadOptions,
    loadingMessage: () => /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownLoading)
  }, getDropDownMenuPosition(), {
    onChange: onChange,
    onFocus: () => setHasBeenFocused(true),
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
    value: value !== null && value !== void 0 ? value : null,
    components: customComponents
  })));
};